import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class OrderDispatchService {

  constructor(private apiService: ApiService) { }

  postPickingDispatch(params: any) {
    return this.apiService.post(`${this.apiService.businessPicking}/picking/dispatch`, params);
  }

  /**
   * Get dispatch images
   * @param companyCode
   * @param dispatchNumber
   */
  getMultimediaImages(companyCode: string, dispatchNumber: string) {
    const params = { companyCode, dispatchNumber };
    return this.apiService.get(`${this.apiService.businessMultimedia}/picking/get-dispatch-images`, params);
  }
}
